import {Address, Admin, MailjetMonitoring, MessagebirdMonitoring, RecipientCountry, Rules, Unsubscribe} from './api'
import {Injectable} from '@angular/core'

@Injectable({providedIn: 'root'})
export class AllServices {
  constructor(
    public Address: Address,
    public Admin: Admin,
    public MailjetMonitoring: MailjetMonitoring,
    public MessagebirdMonitoring: MessagebirdMonitoring,
    public RecipientCountry: RecipientCountry,
    public Rules: Rules,
    public Unsubscribe: Unsubscribe,
  ) {}
}